import { useState, useCallback } from 'react'; // const PREFIX = 'components: Editor: hooks: useNavigation:';

const MODAL_HEADER_TABS = ['Data', 'Selections'];
export default function useNavigation() {
  let {
    isEditingSelections = false,
    onEditDataModalSetup = () => undefined,
    onEditDataModalTeardown = () => undefined,
    onSelectionsModalSetup = () => undefined,
    onSelectionsModalTeardown = () => undefined
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    0: isEditingData,
    1: setIsEditingData
  } = useState(false);
  const {
    0: isShareModalOpen,
    1: setIsShareModalOpen
  } = useState(false);
  const {
    0: activeModalHeaderTab,
    1: setActiveModalHeaderTab
  } = useState(''); // Toggle between Data Editor & Selections
  // modals or close one that's currently open

  const toggleActiveModal = useCallback((tab, payload) => {
    const isToggleEditData = tab === MODAL_HEADER_TABS[0];
    const isToggleSelections = tab === MODAL_HEADER_TABS[1];
    const isActivating = tab && activeModalHeaderTab !== tab;

    if (isToggleEditData) {
      setIsEditingData(true);
      onEditDataModalSetup();
    } else if (isToggleSelections && isActivating) {
      onSelectionsModalSetup(payload);
    }

    if (!isToggleEditData || !isActivating) {
      setIsEditingData(false);
      onEditDataModalTeardown();
    }

    if ((!isToggleSelections || !isActivating) && isEditingSelections) {
      onSelectionsModalTeardown();
    }

    setActiveModalHeaderTab(activeModalHeaderTab === tab ? '' : tab);
  }, [activeModalHeaderTab, setIsEditingData, isEditingSelections, onEditDataModalSetup, onEditDataModalTeardown, onSelectionsModalSetup, onSelectionsModalTeardown]);
  const toggleIsEditingData = useCallback(value => {
    const result = typeof value === 'boolean' ? value : !isEditingData;

    if (result) {
      onEditDataModalSetup();
    } else {
      onEditDataModalTeardown();
    }

    setIsEditingData(result);
  }, [isEditingData, setIsEditingData, onEditDataModalSetup, onEditDataModalTeardown]);
  const toggleIsShareModalOpen = useCallback(value => {
    setIsShareModalOpen(typeof value === 'boolean' ? value : !isShareModalOpen);
  }, [isShareModalOpen, setIsShareModalOpen]);
  return {
    modalHeaderTabs: MODAL_HEADER_TABS,
    isEditingData,
    isShareModalOpen,
    activeModalHeaderTab,
    toggleActiveModal,
    toggleIsEditingData,
    toggleIsShareModalOpen
  };
}